export const ROUTES = {
  main: {
    base: '',
    login: 'login',
    logout: 'logout',
  },
  webinars: {
    base: 'webinars',
    add: 'add',
    view: ':id',
  },
  error: {
    base: 'error',
    notFound: 'not-found',
  },
};
